(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@emotion/styled"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@emotion/styled"], factory);
	else if(typeof exports === 'object')
		exports["swipeableTabs"] = factory(require("react"), require("@emotion/styled"));
	else
		root["swipeableTabs"] = factory(root["React"], root["@emotion/styled"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 